import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

/**
 * Toggle `data-keyboard-up="true"` on `<html>` while the soft keyboard is
 * visible on native. CSS reads the attribute to collapse padding that uses
 * `env(safe-area-inset-bottom)` — that inset keeps reporting the gesture-bar /
 * home-indicator height even after the keyboard has overtaken that physical
 * area, so any `padding-bottom: env(safe-area-inset-bottom)` paints a
 * visible empty strip between the form content and the keyboard top edge.
 *
 * Pair this with the `--cc-safe-area-bottom` CSS variable in index.css —
 * any rule that uses `var(--cc-safe-area-bottom)` instead of the raw `env()`
 * automatically retracts when the keyboard appears.
 *
 * See docs/pro-mobile-keyboard-safe-area.md for the full background and the
 * rolled-back #root-based alternative.
 *
 * Idempotent and fire-and-forget — call once at app boot in main.tsx.
 * No-op on web. Listeners live for the app's lifetime; cleanup is implicit
 * at process exit.
 */
export const initKeyboardSafeArea = (): void => {
  if (!Capacitor.isNativePlatform()) return;

  Keyboard.addListener('keyboardWillShow', () => {
    document.documentElement.dataset.keyboardUp = 'true';
  }).catch(() => undefined);

  Keyboard.addListener('keyboardWillHide', () => {
    delete document.documentElement.dataset.keyboardUp;
  }).catch(() => undefined);
};
